import { create } from 'zustand';

/**
 * Global application store
 * Note: Most data fetching is now handled by React Query.
 * This store only manages authentication state and onboarding flow.
 */
export const useAppStore = create((set) => ({
  // Authentication
  accessKey: null,
  user: null,
  websiteUrl: null,
  isAuthenticated: false,
  isLoggingOut: false,
  isCheckingAuth: true,
  subscription: null,
  loading: false,
  business_name: '',
  logo: '',
  sidebarOpen: false,
  socialAccounts: null,

  // UI State
  setSidebarOpen: (isOpen) => set({ sidebarOpen: isOpen }),

  // Authentication Actions
  setAccessKey: (accessKey) => set({ accessKey, isAuthenticated: !!accessKey }),
  setIsAuthenticated: (isAuthenticated) =>
    set((state) => ({
      isAuthenticated,
      accessKey: isAuthenticated ? state.accessKey : null,
    })),
  setIsAuthenticted: (isAuthenticated) =>
    set((state) => ({
      isAuthenticated,
      accessKey: isAuthenticated ? state.accessKey : null,
    })),
  setUser: (user) => set({ user }),
  setWebsiteUrl: (websiteUrl) => set({ websiteUrl }),

  // Subscription Actions
  setSubscription: (subscription) => set({ subscription }),
  setBusinessName: (business_name) => set({ business_name }),
  setLogo: (logo) => set({ logo }),

  // UI Actions
  setLoading: (loading) => set({ loading }),

  setSocialAccounts: (socialAccounts) => set({ socialAccounts }),

  setIsLoggingOut: (isLoggingOut) => set({ isLoggingOut }),
  setIsCheckingAuth: (isCheckingAuth) => set({ isCheckingAuth }),

  // Reset - Clears all state (used on logout)
  reset: () =>
    set({
      accessKey: null,
      user: null,
      websiteUrl: null,
      isAuthenticated: false,
      subscription: null,
      loading: false,
      business_name: '',
      logo: '',
      sidebarOpen: false,
      socialAccounts: null,
    }),
}));
